import {useEffect} from "react";
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {Container, CreateButton, ProjectCard, ProjectGrid, ProjectContent, ProjectTitle, Description} from "./styled";
import {fetchProjects} from "../../store/reducers/projectSlice";

const Dashboard = () => {
  const projects = useSelector(state => state.project.projects);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProjects());
  }, [dispatch]);

  const navigateToReport = (projectId) => {
    navigate(`/projects/${projectId}`);
  };

  const navigateToCreate = () => {
    navigate('/projects/create');
  };

      return (
        <Container>
          <Description>
            Manage your fusion power plant design projects and costing analyses. 
            Create new projects to explore different reactor configurations and compare costs.
          </Description>
      
      <ProjectGrid>
        {projects.map(project => {
          // Determine background image based on fusion machine type
          const backgroundClass = project.fusionMachineType === 'IFE' ? 'ife' : 'mfe';
          
          return (
            <ProjectCard key={project.projectId} onClick={() => navigateToReport(project.projectId)}>
              <ProjectTitle>
                {project.name || 'Fusion Energy Project'}
              </ProjectTitle>
              <ProjectContent className={backgroundClass}>
                <button className="wh-btn">
                  View Project
                  <i className="fas fa-arrow-right"></i>
                </button>
              </ProjectContent>
            </ProjectCard>
          );
        })}
        
        <CreateButton onClick={navigateToCreate}>
          <span>Create New Project</span>
          <i className="fas fa-plus"></i>
        </CreateButton>
      </ProjectGrid>
    </Container>
  );
};

export default Dashboard;